import React from "react";
import * as api from '../../services/admin'
import AdminForm from './AdminForm'

function Admins(props) {
    const [data, setData] = React.useState({ list: [], isFetching: false });

    function loadData() {
        api.fetch()
            .then(data => {
                setData({ list: data, isFetching: false });
            })
            .catch(error => {
                setData({ list: [], isFetching: false });
            })
    }

    const deleteItem = (e, id) => {
        e.preventDefault();
        api.remove(id)
            .then(data => {
                loadData()
            })
            .catch(error => {
                alert(error);
            })
    }

    const handleSave = (email) => {
        
        api.newAdmin(email)
            .then(data => {
                loadData()
            })
            .catch(error => {
                alert(error);
            })
        
    }
    React.useEffect(() => {
        setData({ list: [], isFetching: true });
        loadData()
    }, []);

    return (
        <div>
            <div className="header">
                <div className="container-fluid">
                    <div className="header-body">
                        <div className="row align-items-end">
                            <div className="col">
                                <h1 className="header-title">Admins</h1>
                            </div>
                            <div className="col-auto">
                                <div>
                                    <button id="form-button" data-toggle="modal" data-target="#admin-form" className="btn btn-sm btn-outline-primary" ><i className="fe fe-plus mr-2"></i> Add new admin</button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
            <AdminForm onSave={handleSave}></AdminForm>
                <div className="card">
                    <div className="card-body">
                        {data.list.map((item, index) => {
                            return (
                                <div key={item}>
                                    <div className="row">
                                        <div className="col">
                                            {item}

                                        </div>
                                        <div className="col text-right">
                                            <button type="button" className="btn btn-sm btn-outline-danger" onClick={(e) => { deleteItem(e, item) }}>Delete</button>
                                        </div>
                                    </div>
                                    {
                                        index === data.list.length - 1 ?
                                            null
                                            : <hr />
                                    }

                                </div>
                            );
                        })
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Admins;